import { render, staticRenderFns } from "./OrderStatistic.vue?vue&type=template&id=f024c0d8&scoped=true&"
import script from "./OrderStatistic.vue?vue&type=script&lang=js&"
export * from "./OrderStatistic.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatistic.vue?vue&type=style&index=0&id=f024c0d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f024c0d8",
  null
  
)

export default component.exports